import React, { useState } from 'react';
import { motion } from 'framer-motion';
import './Schedule.css';
import PPT from './NETCRYPT_2026_PPT_Template.pptx';



const scheduleData = {

  "08-10-2026": {
    day: "THURSDAY",
    date: "08 October 2026",
    time: "02:00 PM – 04:00 PM",

    sessions: [
      {
        number: 1,
        room: "Lab 107 A",
        venue: "Lab 107 A",
        meetLink: "https://us06web.zoom.us/j/82310900277?pwd=a9WVQpUfCsjfd8i6rcb81DFL3pbUoi.1",
        papers: {
          inperson: ["163", "794", "1778", "2138", "2851", "2853"],
          online: ["869", "1993", "2846", "2847"]
        }
      },
      {
        number: 2,
        room: "Lab 107 B",
        venue: "Lab 107 B",
        meetLink: "https://us06web.zoom.us/j/89803833146?pwd=XKCJJqVRI9zVOsSDO1mGL6HIzEH2cN.1",
        papers: {
          inperson: ["775", "784", "808", "1030", "1339", "2753"],
          online: ["171", "623", "820", "1820"]
        }
      },
      {
        number: 3,
        room: "Lab 106",
        venue: "Lab 106",
        meetLink: "https://us06web.zoom.us/j/88227809474?pwd=UxGT4y1zKabqgEDArnIYa6Sd1UT1wc.1",
        papers: {
          inperson: [
            "157", "201", "272", "813", "862",
            "884", "976", "995", "996"
          ],
          online: []
        }
      },
      {
        number: 4,
        room: "Committee Room 103",
        venue: "Committee Room 103",
        meetLink: "https://us06web.zoom.us/j/84450422073?pwd=fzd3jBn2ms3OObZnKJinqC97CF7qdg.1",
        papers: {
          inperson: [
            "1003", "1021", "1049", "1120",
            "1180", "1420", "1462", "1487"
          ],
          online: ["2083"]
        }
      },
      {
        number: 5,
        room: "Lab 112",
        venue: "Lab 112",
        meetLink: "https://us06web.zoom.us/j/85622241793?pwd=lRMAXbqJDby4NL4xIx1a6bAzpfwCT4.1",
        papers: {
          inperson: ["833", "852", "856", "942", "952"],
          online: ["702", "751", "796", "800"]
        }
      },
      {
        number: 6,
        room: "Class Room 01",
        venue: "Classroom 01",
        meetLink: "https://us06web.zoom.us/j/86193182230?pwd=awb3l6xUPRgc03hTw1SgRKu2sO1Gsv.1",
        papers: {
          inperson: ["1119", "1121", "1122", "1141", "1173"],
          online: ["839", "840", "853", "1010", "2926"]
        }
      },
      {
        number: 7,
        room: "Class Room 02",
        venue: "Classroom 02",
        meetLink: "https://us06web.zoom.us/j/87928110438?pwd=juJtWg3tCmKn3PCx37f9mZRjSH6hsq.1",
        papers: {
          inperson: [
            "686", "768", "812", "815", "817",
            "837", "990", "1323", "1330"
          ],
          online: []
        }
      },
      {
        number: 8,
        room: "Class Room 03",
        venue: "Classroom 03",
        meetLink: "https://us06web.zoom.us/j/89903320922?pwd=PimGBNRgZiIU8b5ZOfyLhXK6CxEbfo.1",
        papers: {
          inperson: ["756", "770", "826", "878", "930"],
          online: ["374", "712", "730", "733"]
        }
      },
      {
        number: 9,
        room: "Class Room 04",
        venue: "Classroom 04",
        meetLink: "https://us06web.zoom.us/j/87432018430?pwd=gQZSmylD1xbKdsctKVFOu3Z2To5LSm.1",
        papers: {
          inperson: ["1031", "1336"],
          online: ["774", "798", "889", "890", "1014", "1225", "2205"]
        }
      },
      {
        number: 10,
        room: "Lab 224",
        venue: "Lab 224",
        meetLink: "https://us06web.zoom.us/j/82410949846?pwd=AovpT7Gca0WSqRa7hwmUW79VVVxsgB.1",
        papers: {
          inperson: ["993"],
          online: [
            "918", "957", "958", "988", "1011",
            "1026", "1092", "1245", "2725"
          ]
        }
      }
    ]
  },


  "09-10-2026-AM": {
    day: "FRIDAY",
    date: "09 October 2026",
    time: "09:30 AM – 11:30 AM",

    sessions: [
      {
        number: 11,
        room: "Lab 107 A",
        venue: "Lab 107 A",
        meetLink: "https://us06web.zoom.us/j/82310900277?pwd=a9WVQpUfCsjfd8i6rcb81DFL3pbUoi.1",
        papers: {
          inperson: [],
          online: [
            "997", "1032", "1166", "1280", "1314",
            "1500", "1777", "1975", "2339"
          ]
        }
      },
      {
        number: 12,
        room: "Lab 107 B",
        venue: "Lab 107 B",
        meetLink: "https://us06web.zoom.us/j/89803833146?pwd=XKCJJqVRI9zVOsSDO1mGL6HIzEH2cN.1",
        papers: {
          inperson: [],
          online: [
            "755", "785", "797", "825", "1248",
            "1374", "1480", "1577", "1842", "2083"
          ]
        }
      },
      {
        number: 13,
        room: "Lab 106",
        venue: "Lab 106",
        meetLink: "https://us06web.zoom.us/j/88227809474?pwd=UxGT4y1zKabqgEDArnIYa6Sd1UT1wc.1",
        papers: {
          inperson: [],
          online: [
            "1928", "2326", "2389", "2400", "2466",
            "2513", "2545", "2723", "2750"
          ]
        }
      },
      {
        number: 14,
        room: "Committee Room 103",
        venue: "Committee Room 103",
        meetLink: "https://us06web.zoom.us/j/84450422073?pwd=fzd3jBn2ms3OObZnKJinqC97CF7qdg.1",
        papers: {
          inperson: [],
          online: [
            "1283", "1285", "1333", "1368", "1411",
            "1513", "1533", "1541", "1551"
          ]
        }
      },
      {
        number: 15,
        room: "Lab 112",
        venue: "Lab 112",
        meetLink: "https://us06web.zoom.us/j/85622241793?pwd=lRMAXbqJDby4NL4xIx1a6bAzpfwCT4.1",
        papers: {
          inperson: [],
          online: [
            "1554", "1557", "1590", "1605", "1608",
            "1623", "1631", "1649", "1653"
          ]
        }
      },
      {
        number: 16,
        room: "Class Room 01",
        venue: "Classroom 01",
        meetLink: "https://us06web.zoom.us/j/86193182230?pwd=awb3l6xUPRgc03hTw1SgRKu2sO1Gsv.1",
        papers: {
          inperson: [],
          online: [
            "1659", "1669", "1756", "1759", "1766",
            "1792", "1837", "1849", "1862"
          ]
        }
      },
      {
        number: 17,
        room: "Class Room 02",
        venue: "Classroom 02",
        meetLink: "https://us06web.zoom.us/j/87928110438?pwd=juJtWg3tCmKn3PCx37f9mZRjSH6hsq.1",
        papers: {
          inperson: [],
          online: [
            "1866", "1889", "1916", "2015", "2093",
            "2096", "2097", "2103", "2323"
          ]
        }
      },
      {
        number: 18,
        room: "Class Room 03",
        venue: "Classroom 03",
        meetLink: "https://us06web.zoom.us/j/89903320922?pwd=PimGBNRgZiIU8b5ZOfyLhXK6CxEbfo.1",
        papers: {
          inperson: [],
          online: [
            "2345", "2354", "2357", "2368", "2380",
            "2390", "2401", "2428", "2438"
          ]
        }
      },
      {
        number: 19,
        room: "Class Room 04",
        venue: "Classroom 04",
        meetLink: "https://us06web.zoom.us/j/87432018430?pwd=gQZSmylD1xbKdsctKVFOu3Z2To5LSm.1",
        papers: {
          inperson: [],
          online: [
            "2440", "2444", "2450", "2457", "2481",
            "2496", "2574", "2585", "2613"
          ]
        }
      },
      {
        number: 20,
        room: "Lab 224",
        venue: "Lab 224",
        meetLink: "https://us06web.zoom.us/j/82410949846?pwd=AovpT7Gca0WSqRa7hwmUW79VVVxsgB.1",
        papers: {
          inperson: [],
          online: [
            "2633", "2635", "2636", "2642", "2665",
            "2677", "2717", "2737"
          ]
        }
      },
      {
        number: 21,
        room: "Lab 10",
        venue: "Lab 10",
        meetLink: "https://us06web.zoom.us/j/87347401294?pwd=RHmcLONbUt9t46eIbBOAWT18ujRLme.1",
        papers: {
          inperson: ["1582", "1986", "2079"],
          online: ["193", "696", "1039", "1284", "1454"]
        }
      }
    ]
  },


  "09-10-2026-PM": {
    day: "FRIDAY",
    date: "09 October 2026",
    time: "02:00 PM – 04:00 PM",

    sessions: [
      {
        number: 22,
        room: "Lab 107 A",
        venue: "Lab 107 A",
        meetLink: "https://us06web.zoom.us/j/82310900277?pwd=a9WVQpUfCsjfd8i6rcb81DFL3pbUoi.1",
        papers: {
          inperson: ["2827"],
          online: [
            "736", "2111", "2418", "2748",
            "2843", "2918", "2919", "2920"
          ]
        }
      },
      {
        number: 23,
        room: "Lab 107 B",
        venue: "Lab 107 B",
        meetLink: "https://us06web.zoom.us/j/89803833146?pwd=XKCJJqVRI9zVOsSDO1mGL6HIzEH2cN.1",
        papers: {
          inperson: ["2141", "2621", "2901"],
          online: ["1568", "1651", "1652", "1763", "1896", "2658"]
        }
      },
      {
        number: 24,
        room: "Lab 106",
        venue: "Lab 106",
        meetLink: "https://us06web.zoom.us/j/88227809474?pwd=UxGT4y1zKabqgEDArnIYa6Sd1UT1wc.1",
        papers: {
          inperson: ["1232", "1361", "1370"],
          online: ["1020", "1067", "1105", "1206", "1224", "1478"]
        }
      },
      {
        number: 25,
        room: "Committee Room 103",
        venue: "Committee Room 103",
        meetLink: "https://us06web.zoom.us/j/84450422073?pwd=fzd3jBn2ms3OObZnKJinqC97CF7qdg.1",
        papers: {
          inperson: ["1394", "1702", "1714"],
          online: ["1385", "1429", "1498", "1506", "1674", "1733"]
        }
      },
      {
        number: 26,
        room: "Lab 112",
        venue: "Lab 112",
        meetLink: "https://us06web.zoom.us/j/85622241793?pwd=lRMAXbqJDby4NL4xIx1a6bAzpfwCT4.1",
        papers: {
          inperson: ["1729", "1802"],
          online: [
            "1243", "1758", "1809", "1815",
            "1819", "1821", "1844"
          ]
        }
      },
      {
        number: 27,
        room: "Class Room 01",
        venue: "Classroom 01",
        meetLink: "https://us06web.zoom.us/j/86193182230?pwd=awb3l6xUPRgc03hTw1SgRKu2sO1Gsv.1",
        papers: {
          inperson: ["1811", "2201"],
          online: [
            "1887", "1968", "2099", "2108",
            "2310", "2353", "2361"
          ]
        }
      },
      {
        number: 28,
        room: "Class Room 02",
        venue: "Classroom 02",
        meetLink: "https://us06web.zoom.us/j/87928110438?pwd=juJtWg3tCmKn3PCx37f9mZRjSH6hsq.1",
        papers: {
          inperson: ["2005", "2080"],
          online: [
            "2112", "2126", "2402", "2458",
            "2597", "2609", "2620"
          ]
        }
      },
      {
        number: 29,
        room: "Class Room 03",
        venue: "Classroom 03",
        meetLink: "https://us06web.zoom.us/j/89903320922?pwd=PimGBNRgZiIU8b5ZOfyLhXK6CxEbfo.1",
        papers: {
          inperson: ["1397", "1539", "1834", "2648"],
          online: ["1355", "2740", "2760", "2764", "2779", "2780"]
        }
      },
      {
        number: 30,
        room: "Class Room 04",
        venue: "Classroom 04",
        meetLink: "https://us06web.zoom.us/j/87432018430?pwd=gQZSmylD1xbKdsctKVFOu3Z2To5LSm.1",
        papers: {
          inperson: [
            "2631", "2632", "2649", "2873", "2902"
          ],
          online: ["1463", "2311", "2869"]
        }
      },
      {
        number: 31,
        room: "Lab 224",
        venue: "Lab 224",
        meetLink: "https://us06web.zoom.us/j/82410949846?pwd=AovpT7Gca0WSqRa7hwmUW79VVVxsgB.1",
        papers: {
          inperson: [],
          online: [
            "1384", "1757", "1846", "1956", "2376",
            "2625", "2848", "2849", "2850"
          ]
        }
      },
      {
        number: 32,
        room: "Lab 10",
        venue: "Lab 10",
        meetLink: "https://us06web.zoom.us/j/87347401294?pwd=RHmcLONbUt9t46eIbBOAWT18ujRLme.1",
        papers: {
          inperson: ["2181", "2914", "2922", "2924"],
          online: ["834", "2110", "2113", "2120", "2125"]
        }
      }
    ]
  },


  "10-10-2026": {
    day: "SATURDAY",
    date: "10 October 2026",
    time: "09:30 AM – 11:30 AM",

    sessions: [
      {
        number: 33,
        room: "Lab 107 A",
        venue: "Lab 107 A",
        meetLink: "https://us06web.zoom.us/j/82310900277?pwd=a9WVQpUfCsjfd8i6rcb81DFL3pbUoi.1",
        papers: {
          inperson: ["1535", "2576", "2623", "2651", "2715"],
          online: ["2844", "2845", "2894", "2895"]
        }
      },
      {
        number: 34,
        room: "Lab 107 B",
        venue: "Lab 107 B",
        meetLink: "https://us06web.zoom.us/j/89803833146?pwd=XKCJJqVRI9zVOsSDO1mGL6HIzEH2cN.1",
        papers: {
          inperson: ["1564", "2855", "2886", "2892", "2898"],
          online: ["2570", "2798", "2896", "2897"]
        }
      },
      {
        number: 35,
        room: "Lab 106",
        venue: "Lab 106",
        meetLink: "https://us06web.zoom.us/j/88227809474?pwd=UxGT4y1zKabqgEDArnIYa6Sd1UT1wc.1",
        papers: {
          inperson: ["1892", "2385", "2422", "2607"],
          online: ["1686", "2336", "2751", "2772", "2781", "2782"]
        }
      },
      {
        number: 36,
        room: "Committee Room 103",
        venue: "Committee Room 103",
        meetLink: "https://us06web.zoom.us/j/84450422073?pwd=fzd3jBn2ms3OObZnKJinqC97CF7qdg.1",
        papers: {
          inperson: ["2622", "2854", "2871", "2878", "2893"],
          online: ["2619", "2812", "2833", "2841", "2862"]
        }
      },
      {
        number: 37,
        room: "Lab 112",
        venue: "Lab 112",
        meetLink: "https://us06web.zoom.us/j/85622241793?pwd=lRMAXbqJDby4NL4xIx1a6bAzpfwCT4.1",
        papers: {
          inperson: ["2105", "2381", "2382", "2558"],
          online: ["2591", "2667", "2669", "2770", "2792"]
        }
      },
      {
        number: 38,
        room: "Class Room 01",
        venue: "Classroom 01",
        meetLink: "https://us06web.zoom.us/j/86193182230?pwd=awb3l6xUPRgc03hTw1SgRKu2sO1Gsv.1",
        papers: {
          inperson: ["2611", "2659", "2799"],
          online: ["2592", "2594", "2877", "2879", "2880", "2888"]
        }
      },
      {
        number: 39,
        room: "Class Room 02",
        venue: "Classroom 02",
        meetLink: "https://us06web.zoom.us/j/87928110438?pwd=juJtWg3tCmKn3PCx37f9mZRjSH6hsq.1",
        papers: {
          inperson: ["2188", "2664", "2826", "2835", "2868", "2899"],
          online: ["1983", "2612", "2614", "2634"]
        }
      },
      {
        number: 40,
        room: "Class Room 03",
        venue: "Classroom 03",
        meetLink: "https://us06web.zoom.us/j/89903320922?pwd=PimGBNRgZiIU8b5ZOfyLhXK6CxEbfo.1",
        papers: {
          inperson: ["1156", "1737", "1794", "1817", "1824"],
          online: ["2783", "2784", "2785", "2796"]
        }
      },
      {
        number: 41,
        room: "Class Room 04",
        venue: "Classroom 04",
        meetLink: "https://us06web.zoom.us/j/87432018430?pwd=gQZSmylD1xbKdsctKVFOu3Z2To5LSm.1",
        papers: {
          inperson: ["1856", "1860", "1939", "2360", "2363"],
          online: ["2800", "2821", "2858", "2861"]
        }
      },
      {
        number: 42,
        room: "Lab 224",
        venue: "Lab 224",
        meetLink: "https://us06web.zoom.us/j/82410949846?pwd=AovpT7Gca0WSqRa7hwmUW79VVVxsgB.1",
        papers: {
          inperson: ["2378", "2399", "2497", "2498", "2565"],
          online: ["2867", "2875", "2876", "2881"]
        }
      }
    ]
  }

};



function Schedule() {

  const [activeDay, setActiveDay] = useState("08-10-2026");

  const activeSchedule = scheduleData[activeDay];


  return (
    <div className="schedule-page">

      {/* =========================
          HERO
      ========================= */}

      <motion.div
        className="schedule-hero"
        initial={{ opacity: 0, y: 25 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >

        <div className="schedule-label">
          NETCRYPT 2026
        </div>

        <h1>
          Program Schedule
        </h1>

        <p>
          Tentative Papers Presentation Schedule
        </p>

        <h5 style={{color: "#dc3545", fontWeight: "bold", textAlign: "center"}}>
          Venue: School of Computer Science, Jawaharlal Nehru University, New Delhi, India
        </h5>

        <div className="hero-line my-4"></div>

        <a
            role="button"
            className="btn btn-outline-danger"
            href={PPT}
            target="_blank"
            rel="noopener noreferrer"
            download
          >
           <h3><strong>Presentation Template</strong></h3>
          </a>

  

      </motion.div>

      


      {/* =========================
          DAY SELECTOR
      ========================= */}

      <div className="day-selector">

        <button
          className={
            activeDay === "08-10-2026"
              ? "day-button active"
              : "day-button"
          }
          onClick={() => setActiveDay("08-10-2026")}
        >
          <span>08 OCT</span>
          <small>THURSDAY</small>
        </button>


        <button
          className={
            activeDay === "09-10-2026-AM"
              ? "day-button active"
              : "day-button"
          }
          onClick={() => setActiveDay("09-10-2026-AM")}
        >
          <span>09 OCT</span>
          <small>FRIDAY · MORNING</small>
        </button>


        <button
          className={
            activeDay === "09-10-2026-PM"
              ? "day-button active"
              : "day-button"
          }
          onClick={() => setActiveDay("09-10-2026-PM")}
        >
          <span>09 OCT</span>
          <small>FRIDAY · AFTERNOON</small>
        </button>


        <button
          className={
            activeDay === "10-10-2026"
              ? "day-button active"
              : "day-button"
          }
          onClick={() => setActiveDay("10-10-2026")}
        >
          <span>10 OCT</span>
          <small>SATURDAY</small>
        </button>

      </div>


      {/* =========================
          DATE HEADER
      ========================= */}

      <motion.div
        key={activeDay}
        className="date-header"
        initial={{ opacity: 0, x: -15 }}
        animate={{ opacity: 1, x: 0 }}
      >

        <div>
          <span className="date-day">
            {activeSchedule.day}
          </span>

          <h2>
            {activeSchedule.date}
          </h2>
        </div>


        <div className="time-box">

          <span>
            Presentation Time
          </span>

          <strong>
            {activeSchedule.time}
          </strong>

        </div>

      </motion.div>


      {/* =========================
          SESSIONS
      ========================= */}

      <motion.div
        key={`sessions-${activeDay}`}
        className="sessions-container"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
      >

        {activeSchedule.sessions.map((session) => (

          <motion.div
            key={session.number}
            className="session-card"
            initial={{ opacity: 0, y: 15 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >

            {/* Session Number */}

            <div className="session-number">

              <span>
                SESSION
              </span>

              <strong>
                {session.number}
              </strong>

            </div>


            {/* Session Content */}

            <div className="session-content">


             {/* =========================
                    VENUE + GOOGLE MEET
                ========================= */}

                {(session.venue || session.meetLink) && (

                  <div className="session-info">


                    {/* Session Venue */}

                    {session.venue && (

                      <div className="venue-info">

                        <span className="info-icon">
                          📍
                        </span>

                        <div>

                          <small>
                            Session Venue
                          </small>

                          <strong>
                            {session.venue}
                          </strong>

                        </div>

                      </div>

                    )}


                    {/* Google Meet */}

                    {session.meetLink && (

                      <div className="meet-info">

                        <span className="info-icon">
                          🎥
                        </span>

                        <div>

                          <small>
                            Online Session
                          </small>

                          <a
                            href={session.meetLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Join Meeting
                          </a>

                        </div>

                      </div>

                    )}

                  </div>

                )}


              {/* =========================
                  IN PERSON PAPERS
              ========================= */}

              {session.papers.inperson.length > 0 && (

                <div className="mode-block inperson">

                  <div className="mode-title">

                    <span className="mode-dot"></span>

                    IN PERSON

                  </div>


                  <div className="paper-list">

                    {session.papers.inperson.map((paper) => (

                      <span
                        key={paper}
                        className="paper-id"
                      >
                        {paper}
                      </span>

                    ))}

                  </div>

                </div>

              )}


              {/* =========================
                  ONLINE PAPERS
              ========================= */}

              {session.papers.online.length > 0 && (

                <div className="mode-block online">

                  <div className="mode-title">

                    <span className="mode-dot"></span>

                    ONLINE

                  </div>


                  <div className="paper-list">

                    {session.papers.online.map((paper) => (

                      <span
                        key={paper}
                        className="paper-id"
                      >
                        {paper}
                      </span>

                    ))}

                  </div>

                </div>

              )}

            </div>

          </motion.div>

        ))}

      </motion.div>


      {/* =========================
          PDF DOWNLOAD
      ========================= */}

      {/* <div className="pdf-section">

        <div>

          <h3>
            Need the complete schedule?
          </h3>

          <p>
            Download the official NETCRYPT 2026 schedule PDF.
          </p>

        </div>


        <a
          href="/schedule.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="pdf-button"
        >
          ↗ View Full PDF
        </a>

      </div> */}


      {/* =========================
          NOTICE
      ========================= */}

      <div className="schedule-notice">

        <strong>
          Note:
        </strong>{' '}

        This is a tentative schedule and may be subject to updates.

      </div>

    </div>
  );
}

export default Schedule;